import Layout from "../Shared/Layout";
import Login from "./Login";

const LoginPage = () => {
    return (
        <Layout>
            <Login />
        </Layout>
    )
}

export default LoginPage;